module.exports = __webpack_public_path__ + "img/img_toss.da45c900.png";